<template>
  <!-- 交易链接订单 -->
  <div class="repair_order-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.transaction_url"
            placeholder="请输入交易链接数字"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.type" @change="getData(1)">
            <el-option :value="undefined" label="请选择订单来源"
              >全部</el-option
            >
            <el-option :value="1" label="商城"></el-option>
            <el-option :value="2" label="取回"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="buttonLoading"
            @click="handleExport"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="listData" v-loading="loading">
        <el-table-column prop="transaction_url" label="交易链接" align="center">
        </el-table-column>
        <el-table-column label="交易金额" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.cost_price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="订单来源" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.type }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_count" label="用户数量" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="primary" @click="openUserDetails(row)"
              >用户详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <UserDetailsDialog
      :visible="dialogVisible"
      @close="dialogVisible = false"
      v-model="dialogInfo"
    ></UserDetailsDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import UserDetailsDialog from '@/components/order/transaction_link/UserDetailsDialog.vue'

export default {
  components: {
    UserDetailsDialog
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
        transaction_url: undefined,//交易链接
        type: undefined,//订单来源
        start_time: undefined,//开始时间
        end_time: undefined,//结束时间
      },
      dialogInfo: undefined,//传给弹窗是数据
      listData: undefined,//数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        //点击查询是还原下标
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('extract_transaction_url', params)
        .then(res => {
          this.listData = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    openUserDetails(rowInfo) {
      // 打开查看用户详情
      this.dialogVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
      this.dialogInfo.start_time = this.query.start_time
      this.dialogInfo.end_time = this.query.end_time
    },
    handleExport() {
      //保存任务
      this.buttonLoading = true
      let params = this.query

      http
        .post(
          api + 'extract_transaction_url_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '交易链接订单.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    }
  },
}
</script>
<style lang="less" scoped>
</style>